import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import TextInput from "src/components/common/TextInput";
import List from "src/components/common/List";
import ComItem from "src/components/manage/ComItem";
import BottomFixed from "src/components/common/BottomFixed";
import IconButton from "src/components/common/IconButton";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import ShopItem from "src/components/manage/ShopItem";
import { useAppSelector } from "src/store/actions/action";
import { useAddGroupNameMutation, useAddGroupStoreMutation, useSelectGroupQuery, useSelectGroupStoreQuery, useUpdateGroupStoreMutation } from "src/api/userAPI";
import { getPathValue } from "src/utils/queryStringUtil";
import PaginationCommon from "src/components/common/PaginationCommon";
import setQueryStringVer from "src/utils/reuseQueryString";
import { RotatingLines } from "react-loader-spinner";

/**
 * 그룹을 실제로 저장, 수정, 삭제 하는 곳
 * 매장 목록(apiData, add에서 추가한 데이터) 이 나오는 곳은 ShopItem.tsx
 * @returns
 */
function groupEdit() {
  //  글로벌 초기 값
  const userInfo = useAppSelector((state) => state.userReduce.userInfo);

  const navigate = useNavigate();
  const navigateState = useLocation();
  const group_index: any = getPathValue();

  // 초기 값 세팅
  const [inputs, setInputs] = useState({
    groupName: "",
    searchStoreName: "",
    totalPages: 0,
    currentPage: 0,
    filterData: "",
  });
  const { groupName, searchStoreName, totalPages, currentPage, filterData } = inputs;

  const [rerender, setRerender] = useState(false);

  const [groupIndex, setGroupIndex] = useState();

  const [apiSkip, setApiSkip] = useState(true);
  const [reApiSkip, setReApiSkip] = useState(true);

  const [page, setPage] = useState(1);

  const [navigateStateDate, setNavigateStateData] = useState<any>(navigateState.state);

  const [queryString, setQueryString] = useState({
    pageSearchNumber: 1,
  });

  const [registerGroupData, setRegisterGroupData] = useState({});

  //API 영역
  const groupStoreAPI = useSelectGroupStoreQuery({ groupId: group_index, queryString: filterData }, { skip: apiSkip });

  // 수정 API
  const [updateGroupAPI, { error: updateError, isSuccess: updateIsSuccess, isLoading: updateIsLoading }] = useUpdateGroupStoreMutation();

  // 등록 API
  const [insetGroupAPI, { error: groupError, isSuccess: groupIsSuccess, isLoading: groupIsLoading, data: groupData }] = useAddGroupNameMutation();

  const [insetGroupStoreAPI, { error: groupStoreError, isSuccess: groupStoreIsSuccess, isLoading: groupStoreIsLoading }] = useAddGroupStoreMutation();

  // 생명주기 영역

  useEffect(() => {
    setInputs({
      ...inputs,
      currentPage: 0,
    });
  }, []);

  useEffect(() => {
    const filter = setQueryStringVer(queryString);
    setInputs({
      ...inputs,
      filterData: filter,
    });
    setApiSkip(false);
  }, [queryString]);

  useEffect(() => {
    if (group_index) {
      setApiSkip(false);
    } else {
      setApiSkip(true);
    }
  }, [group_index]);

  useEffect(() => {
    if (groupStoreAPI.isSuccess) {
      setInputs({
        ...inputs,
        currentPage: groupStoreAPI.data.meta.currentPage,
        totalPages: groupStoreAPI.data.meta.totalPages,
      });
      setRegisterGroupData(groupStoreAPI);
    } else {
      setInputs({
        ...inputs,
        currentPage: 1,
        totalPages: 1,
      });
    }
  }, [groupStoreAPI]);

  useEffect(() => {
    if (navigateStateDate.groupName) {
      setInputs({
        ...inputs,
        groupName: navigateStateDate.groupName,
      });
    }
  }, [navigateStateDate.groupName]);

  // 그룹을 신규 등록 할때는 그룹 name을 먼저 저장하고 그 index를 가지고 와서 다시 저장 하는 방식
  useEffect(() => {
    if (groupIsSuccess) {
      setGroupIndex(groupData.data.group_part_idx);
    }
  }, [groupIsSuccess]);

  useEffect(() => {
    if (groupIndex) {
      const formArray = [];
      for (let i = 0; i < navigateStateDate.send.length; i++) {
        formArray.push({
          group_part_idx: groupIndex,
          store_id: navigateStateDate.send[i].user_id,
        });
      }
      insetGroupStoreAPI(formArray);
    }
  }, [groupIndex]);

  useEffect(() => {
    if (groupStoreIsSuccess) {
      navigate("/manage-list");
    }
  }, [groupStoreIsSuccess]);

  useEffect(() => {
    if (updateIsSuccess) {
      navigate("/manage-list");
    }
  }, [updateIsSuccess]);

  // 이벤트 영역
  // 저장 버튼 클릭
  const groupRegister = async () => {
    if (group_index) {
      if (navigateStateDate.send) {
        const storeArray = [];

        for (let i = 0; i < navigateStateDate.send.length; i++) {
          storeArray.push({
            user_id: navigateStateDate.send[i].user_id,
          });
        }

        const form = {
          group_part_idx: group_index,
          data: {
            group_purpose: "",
            group_name: groupName,
            insert_user: storeArray,
          },
        };
        await updateGroupAPI(form);
      } else {
        const form = {
          group_part_idx: group_index,
          data: {
            group_purpose: "",
            group_name: groupName,
          },
        };
        await updateGroupAPI(form);
      }
    } else {
      const form = {
        group_name: groupName,
        group_purpose: "",
        user_id: userInfo.user_id,
        group_type: "S",
      };
      await insetGroupAPI(form);
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setInputs({
      ...inputs,
      groupName: value,
    });
  };

  const objectChange = (currentPage: number) => {
    setPage(currentPage);
    setQueryString({
      ...queryString,
      pageSearchNumber: currentPage,
    });
  };

  const refetchFunc = () => {
    setRerender(!rerender);
    setReApiSkip(false);
    groupStoreAPI.refetch();
    // refetch();
  };

  const groupAddViewClick = () => {
    const navigateName = group_index ? "/group-add/" + group_index : "/group-add";
    if (navigateStateDate.send) {
      if (navigateStateDate.send.length > 0) {
        if (!confirm("다시 선택 하시겠습니까? \n 방금 선택한 대상은 저장되지 않습니다. \n 원치 않으실 경우 ‘저장’ 후 추가해주세요.")) {
          return;
        }
      }
    }
    navigate(navigateName, { state: { groupName: groupName } });
  };

  // const plusBtnClick = useCallback(() => {
  //   //
  //   if (navigateStateDate.send) {
  //     if (confirm("다시 대상선택을 하시겠습니까? \n 방금 선택한 대상은 저장되지 않습니다.")) {
  //       return group_index ? "/group-add/" + group_index : "/group-add";
  //     } else {
  //       return "#";
  //     }
  //   }
  //   return group_index ? "/group-add/" + group_index : "/group-add";
  // }, []);

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            그룹편집
          </Button>
        </div>
        <div className="btn-box">
          <Button variant="text" onClick={groupRegister}>
            {groupStoreIsLoading ? (
              <p style={{ textAlign: "center" }}>
                <RotatingLines width="20" strokeColor="#00263e" strokeWidth="1" />
              </p>
            ) : (
              "저장"
            )}
          </Button>
        </div>
      </header>

      <Body>
        <Box pd="20px 15px">
          <LabelInputSet>
            <dt>이름</dt>
            <dd>
              <TextInput
                variant="contained"
                type="text"
                id="groupName"
                name="name-id01"
                value={groupName}
                maxLength={10}
                onChange={(e) => onChange(e)}
                readonly={false}
              />
            </dd>
          </LabelInputSet>
        </Box>

        <TotalNumberSet>{/* 총 <span>{groupStoreAPI.isSuccess ? groupStoreAPI.data.meta.totalItems : ""}</span>개 */}</TotalNumberSet>

        <List pd="0 15px" itemPd="25px 0">
          {/* 매장추가일때 */}
          <ShopItem deleteMode addData={navigateState.state} registeredAPIdata={registerGroupData} refetchFunc={refetchFunc} />
          {/* 업체추가일때 */}
          <ComItem deleteMode />
        </List>

        {totalPages > 1 && (
          <PaginationCommon item_count={10} current_page={currentPage} total_page={totalPages} objectChange={objectChange} viewName="manage" />
        )}

        <BottomFixed>
          <div
            onClick={groupAddViewClick}
            // to={"#"}
            // to={group_index ? "/group-add/" + group_index : "/group-add"}
            // state={{ groupName: groupName }}
          >
            <IconButton btnName="그룹추가">
              <SVG name="write" width={53} height={53} viewBox="0 0 53 53" />
            </IconButton>
          </div>
        </BottomFixed>
      </Body>
    </>
  );
}

const LabelInputSet = styled.dl`
  ${({ theme }) => theme.flexBox.flexMixin()}
  dt {
    flex-basis: 75px;
    font-size: 16px;
    font-weight: 500;
  }
  dd {
    flex: 1 0 auto;
  }
`;

const TotalNumberSet = styled.p`
  padding: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  color: ${({ theme }) => theme.color.secondary};
  text-align: right;
`;

export default groupEdit;
